// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"328":"admin","378":"user"}[chunkId] + "." + {"328":"330c6bf4","378":"dffa7aa5"}[chunkId] + ".css";
};